import { CommonModule } from '@angular/common';
import {
  Component,
  computed,
  EventEmitter,
  Input,
  Output,
  signal,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'app-accordion',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './accordion.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './accordion.component.css',
})
export class AccordionComponent {
  @Input() set isOpen(value: boolean) {
    this.openState.set(value);
  }

  @Input() headerText?: string;
  @Input() headerContent?: TemplateRef<void>;
  @Input() openIcon = 'chevron-up';
  @Input() closeIcon = 'chevron-down';
  /** Optional data-testid for the clickable header toggle (e2e testing) */
  @Input() headerTestId?: string;

  @Output() onToggle = new EventEmitter<boolean>();

  openState = signal(true);

  // Computed signal for current icon name (useful for testing)
  currentIcon = computed(() => (this.openState() ? this.openIcon : this.closeIcon));

  toggle(): void {
    const newState = !this.openState();
    this.openState.set(newState);
    this.onToggle.emit(newState);
  }
}
